import React from 'react'

const RejectionTemplate = ({ data }) => {
  const {
    studentName = '',
    companyName = '',
    roleName = '',
    roundName = '',
    signatureName = '',
    signatureRole = '',
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      <p>Hi {studentName},</p>

      <p style={{ paddingTop: '8px' }}>
        We regret to inform you that you haven't been selected following the
        recent {roundName} for {roleName} at {companyName}.
      </p>

      <p style={{ paddingTop: '8px' }}>
        Thank you for your participation.
      </p>

      <p style={{ paddingTop: '10px', paddingBottom: '2px', margin: '0px' }}>Best regards,</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureName}</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureRole}</p>
    </div>
  )
}

export default RejectionTemplate
